module.exports = __webpack_public_path__ + "static/media/dashboard.b7c9bfd9.svg";